import { RouterProvider } from 'react-router';
import projectRouters from './routers/router';

function RootApp() {
  return <RouterProvider router={projectRouters} />;
}

export default RootApp;
